(function () {
  var RECENT_KEY = 'tbd_recently_viewed';
  var LEGACY_RECENT_KEY = 'vervewave_recently_viewed';
  var WISHLIST_KEY = 'tbd_saved_products';

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function readRecent() {
    try {
      var saved = localStorage.getItem(RECENT_KEY);
      if (!saved) saved = localStorage.getItem(LEGACY_RECENT_KEY);
      return JSON.parse(saved || '[]');
    } catch (error) {
      return [];
    }
  }

  function writeRecent(items) {
    localStorage.setItem(RECENT_KEY, JSON.stringify(items.slice(0, 12)));
  }

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items.slice(0, 60)));
    updateWishlistUI();
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'USD'
    }).format((Number(cents) || 0) / 100);
  }

  function trackCurrentProduct() {
    var node = qs('[data-current-product]');
    if (!node) return;

    try {
      var product = JSON.parse(node.textContent);
      var items = readRecent().filter(function (item) {
        return item.id !== product.id;
      });
      items.unshift(product);
      writeRecent(items);
    } catch (error) {
      return;
    }
  }

  function renderRecent() {
    var wrap = qs('[data-recently-viewed]');
    var grid = qs('[data-recently-viewed-grid]');
    if (!wrap || !grid) return;

    var items = readRecent().slice(0, 8);
    if (!items.length) return;

    grid.innerHTML = items.map(function (item) {
      var image = item.image
        ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
        : '<span>No image</span>';
      return [
        '<article class="recent-product-card">',
        '<a class="recent-product-card__image" href="' + item.url + '">' + image + '</a>',
        '<div class="recent-product-card__body">',
        '<a class="recent-product-card__title" href="' + item.url + '">' + escapeHtml(item.title) + '</a>',
        '<div class="recent-product-card__price">' + escapeHtml(item.price) + '</div>',
        '</div>',
        '</article>'
      ].join('');
    }).join('');

    wrap.hidden = false;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      })[char];
    });
  }

  function updateCartCounts(cart) {
    qsa('[data-cart-count]').forEach(function (count) {
      count.textContent = cart.item_count;
    });
  }

  function initBackToTop() {
    var button = qs('[data-back-to-top]');
    if (!button || button.dataset.backToTopReady === 'true') return;
    button.dataset.backToTopReady = 'true';

    var configuredOffset = Number(button.getAttribute('data-show-after')) || 500;
    var ticking = false;

    function update() {
      var header = qs('[data-header]');
      var headerOffset = header ? header.offsetHeight + 120 : 0;
      var visible = window.scrollY > Math.max(configuredOffset, headerOffset);
      button.classList.toggle('is-visible', visible);
      button.setAttribute('aria-hidden', visible ? 'false' : 'true');
      button.tabIndex = visible ? 0 : -1;
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    button.addEventListener('click', function () {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  }

  function showCartToast(productTitle) {
    var toast = qs('[data-cart-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      toast.setAttribute('data-cart-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = [
        '<button class="cart-toast__close" type="button" aria-label="Close notification"></button>',
        '<strong data-cart-toast-title>Added to cart</strong>',
        '<span>You can keep shopping or review your order.</span>',
        '<div><a href="/cart">View cart</a><a href="/checkout">Checkout</a></div>'
      ].join('');
      document.body.appendChild(toast);
      qs('.cart-toast__close', toast).addEventListener('click', function () {
        toast.classList.remove('is-visible');
      });
    }

    var title = qs('[data-cart-toast-title]', toast);
    title.textContent = productTitle ? productTitle + ' added to cart' : 'Added to cart';
    window.clearTimeout(toast.hideTimer);
    toast.classList.add('is-visible');
    toast.hideTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 5200);
  }

  function showUtilityToast(message) {
    var toast = qs('[data-utility-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'utility-toast';
      toast.setAttribute('data-utility-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    window.clearTimeout(toast.hideTimer);
    toast.classList.add('is-visible');
    toast.hideTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  function wishlistProductForButton(button) {
    var scope = button.closest('[data-product-commerce], .product-card');
    var node = scope ? qs('[data-wishlist-product], [data-card-wishlist-product]', scope) : null;
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function updateWishlistUI() {
    var items = readWishlist();
    var ids = items.map(function (item) { return String(item.id); });
    qsa('[data-wishlist-count]').forEach(function (count) {
      count.textContent = items.length;
      count.hidden = items.length === 0;
    });
    qsa('[data-wishlist-toggle]').forEach(function (button) {
      var product = wishlistProductForButton(button);
      var active = product && ids.indexOf(String(product.id)) !== -1;
      button.classList.toggle('is-active', Boolean(active));
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('title', active ? 'Remove from saved products' : 'Save product');
      var label = qs('[data-wishlist-label]', button);
      if (label) label.textContent = active ? 'Remove from saved products' : 'Save product';
    });
  }

  function initWishlist(root) {
    qsa('[data-wishlist-toggle]', root).forEach(function (button) {
      if (button.dataset.wishlistReady === 'true') return;
      button.dataset.wishlistReady = 'true';
      button.addEventListener('click', function () {
        var product = wishlistProductForButton(button);
        if (!product) return;
        var items = readWishlist();
        var index = items.findIndex(function (item) { return String(item.id) === String(product.id); });
        if (index === -1) {
          items.unshift(product);
          showUtilityToast('Saved to your product list');
        } else {
          items.splice(index, 1);
          showUtilityToast('Removed from saved products');
        }
        writeWishlist(items);
        renderWishlist();
      });
    });
    updateWishlistUI();
  }

  function initProductSharing(root) {
    qsa('[data-share-product]', root).forEach(function (button) {
      if (button.dataset.shareReady === 'true') return;
      button.dataset.shareReady = 'true';
      button.addEventListener('click', function () {
        var product = wishlistProductForButton(button);
        var payload = { title: product ? product.title : document.title, url: window.location.href };
        if (navigator.share) {
          navigator.share(payload).catch(function () {});
          return;
        }
        if (navigator.clipboard) {
          navigator.clipboard.writeText(payload.url).then(function () {
            showUtilityToast('Product link copied');
          });
        }
      });
    });
  }

  function initProductRecommendations(root) {
    qsa('[data-product-recommendations]', root).forEach(function (section) {
      if (section.dataset.recommendationsReady === 'true') return;
      section.dataset.recommendationsReady = 'true';

      function loadRecommendations() {
        var url = section.getAttribute('data-url');
        if (!url) return;
        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (text) {
            var html = document.createElement('div');
            html.innerHTML = text;
            var remoteSection = qs('[data-product-recommendations]', html);
            var shell = remoteSection ? qs('.product-recommendations-shell', remoteSection) : null;
            if (!shell || shell.getAttribute('data-has-products') !== 'true') return;
            section.innerHTML = remoteSection.innerHTML;
            section.hidden = false;
            initQuickAdd(section);
            initWishlist(section);
          })
          .catch(function () {
            section.hidden = true;
          });
      }

      loadRecommendations();
    });
  }

  function initBrandDirectories(root) {
    qsa('[data-brand-directory]', root).forEach(function (directory) {
      var input = qs('[data-brand-search]', directory);
      if (!input || input.dataset.brandSearchReady === 'true') return;
      input.dataset.brandSearchReady = 'true';
      var cards = qsa('[data-brand-card]', directory);
      var empty = qs('[data-brand-empty]', directory);

      input.addEventListener('input', function () {
        var term = input.value.trim().toLowerCase();
        var visible = 0;
        cards.forEach(function (card) {
          var matches = !term || (card.getAttribute('data-brand-name') || '').indexOf(term) !== -1;
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
      });
    });
  }

  function initArticleTools(root) {
    qsa('[data-article-shell]', root).forEach(function (shell) {
      if (shell.dataset.articleReady === 'true') return;
      shell.dataset.articleReady = 'true';

      var body = qs('[data-article-body]', shell);
      var toc = qs('[data-article-toc]', shell);
      var tocList = qs('[data-article-toc-list]', shell);

      if (body && toc && tocList) {
        var headings = qsa('h2', body);
        var usedIds = {};
        var tocItems = headings.map(function (heading, index) {
          var base = heading.id || String(heading.textContent || '')
            .toLowerCase()
            .normalize('NFKD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '') || 'section-' + (index + 1);
          var nextId = base;
          var duplicate = 1;
          while (usedIds[nextId]) {
            duplicate += 1;
            nextId = base + '-' + duplicate;
          }
          usedIds[nextId] = true;
          heading.id = nextId;
          return '<li><a href="#' + nextId + '">' + escapeHtml(heading.textContent) + '</a></li>';
        });

        if (tocItems.length) {
          tocList.innerHTML = tocItems.join('');
          toc.hidden = false;
          var articleLayout = toc.closest('.article-layout');
          if (articleLayout) articleLayout.classList.add('has-toc');

          if ('IntersectionObserver' in window) {
            var tocLinks = qsa('a', tocList);
            var headingObserver = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                tocLinks.forEach(function (link) {
                  if (link.getAttribute('href') === '#' + entry.target.id) link.setAttribute('aria-current', 'location');
                  else link.removeAttribute('aria-current');
                });
              });
            }, { rootMargin: '-18% 0px -70% 0px' });
            headings.forEach(function (heading) { headingObserver.observe(heading); });
          }
        }
      }

      var shareButton = qs('[data-article-share]', shell);
      if (shareButton) {
        shareButton.addEventListener('click', function () {
          var payload = {
            title: shareButton.getAttribute('data-share-title') || document.title,
            url: shareButton.getAttribute('data-share-url') || window.location.href
          };
          if (navigator.share) {
            navigator.share(payload).catch(function () {});
            return;
          }
          if (navigator.clipboard) {
            navigator.clipboard.writeText(payload.url).then(function () {
              showUtilityToast('Guide link copied');
            });
          }
        });
      }
    });
  }

  function wishlistCardMarkup(item) {
    var image = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
      : '<span class="wishlist-card__placeholder">No image</span>';
    var compare = item.compareAtPrice > item.price
      ? '<s>' + formatMoney(item.compareAtPrice, item.currency) + '</s>'
      : '';
    var action = item.available && item.hasOnlyDefaultVariant
      ? '<form method="post" action="/cart/add" class="quick-add-form" data-product-title="' + escapeHtml(item.title) + '"><input type="hidden" name="id" value="' + escapeHtml(item.variantId) + '"><input type="hidden" name="quantity" value="1"><button class="button primary full" type="submit">Add to cart</button></form>'
      : '<a class="button secondary full" href="' + escapeHtml(item.url) + '">' + (item.available ? 'Choose options' : 'View product') + '</a>';
    return [
      '<article class="wishlist-card" data-wishlist-item="' + escapeHtml(item.id) + '">',
      '<button class="wishlist-card__remove" type="button" data-wishlist-remove="' + escapeHtml(item.id) + '" aria-label="Remove ' + escapeHtml(item.title) + '">×</button>',
      '<a class="wishlist-card__image" href="' + escapeHtml(item.url) + '">' + image + '</a>',
      '<div class="wishlist-card__body">',
      '<a class="wishlist-card__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>',
      '<div class="wishlist-card__price"><strong>' + formatMoney(item.price, item.currency) + '</strong>' + compare + '</div>',
      '<span class="stock ' + (item.available ? 'in-stock' : 'out-stock') + '">' + (item.available ? 'In stock' : 'Check availability') + '</span>',
      action,
      '</div></article>'
    ].join('');
  }

  function renderWishlist() {
    var grid = qs('[data-wishlist-grid]');
    var empty = qs('[data-wishlist-empty]');
    var count = qs('[data-wishlist-page-count]');
    if (!grid) return;
    var items = readWishlist();
    grid.innerHTML = items.map(wishlistCardMarkup).join('');
    if (empty) empty.hidden = items.length > 0;
    grid.hidden = items.length === 0;
    if (count) count.textContent = items.length + (items.length === 1 ? ' product' : ' products');
    qsa('[data-wishlist-remove]', grid).forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-wishlist-remove');
        writeWishlist(readWishlist().filter(function (item) { return String(item.id) !== String(id); }));
        renderWishlist();
      });
    });
    initQuickAdd(grid);
  }

  function initMenu() {
    var toggle = qs('[data-menu-toggle]');
    var menu = qs('[data-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      menu.classList.toggle('is-open');
    });
  }

  function initCategoryFlyouts() {
    qsa('[data-category-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.hero-cat-item');
        if (!item) return;
        qsa('.hero-cat-item.is-open').forEach(function (openItem) {
          if (openItem !== item) openItem.classList.remove('is-open');
        });
        item.classList.toggle('is-open');
      });
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.hero-category-menu')) return;
      qsa('.hero-cat-item.is-open').forEach(function (item) {
        item.classList.remove('is-open');
      });
    });
  }

  function initCountdown() {
    qsa('[data-countdown]').forEach(function (node) {
      var end = new Date(node.getAttribute('data-countdown-end')).getTime();
      if (!end) return;

      function render() {
        var remaining = Math.max(0, end - Date.now());
        var days = Math.floor(remaining / 86400000);
        var hours = Math.floor((remaining % 86400000) / 3600000);
        var minutes = Math.floor((remaining % 3600000) / 60000);
        qs('[data-days]', node).textContent = String(days).padStart(2, '0');
        qs('[data-hours]', node).textContent = String(hours).padStart(2, '0');
        qs('[data-minutes]', node).textContent = String(minutes).padStart(2, '0');
      }

      render();
      setInterval(render, 60000);
    });
  }

  function initPredictiveSearch() {
    var input = qs('[data-predictive-input]');
    var panel = qs('[data-predictive-panel]');
    if (!input || !panel) return;

    var form = input.closest('form');
    var scope = form ? qs('[data-search-scope]', form) : null;
    var shortcutsNode = qs('[data-search-shortcuts]');
    var shortcuts = [];
    if (shortcutsNode) {
      try {
        shortcuts = JSON.parse(shortcutsNode.textContent || '[]');
      } catch (error) {
        shortcuts = [];
      }
    }

    var timer = null;

    function syncScopeWidth() {
      if (!form || !scope) return;

      var styles = window.getComputedStyle(scope);
      var probe = document.createElement('span');
      var widestLabel = 0;
      probe.setAttribute('aria-hidden', 'true');
      probe.style.position = 'fixed';
      probe.style.left = '-9999px';
      probe.style.visibility = 'hidden';
      probe.style.whiteSpace = 'nowrap';
      probe.style.font = styles.font;
      probe.style.fontWeight = styles.fontWeight;
      document.body.appendChild(probe);

      Array.prototype.forEach.call(scope.options, function (option) {
        probe.textContent = option.textContent.trim();
        widestLabel = Math.max(widestLabel, probe.getBoundingClientRect().width);
      });

      probe.remove();

      var compact = window.matchMedia('(max-width: 640px)').matches;
      var minimum = compact ? 74 : 82;
      var maximum = compact ? 156 : 176;
      var arrowAndPadding = compact ? 46 : 52;
      var width = Math.min(maximum, Math.max(minimum, Math.ceil(widestLabel + arrowAndPadding)));

      form.style.setProperty('--search-scope-width', width + 'px');
      scope.title = scope.options[scope.selectedIndex].textContent.trim();
    }

    syncScopeWidth();
    window.addEventListener('resize', syncScopeWidth);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncScopeWidth);
    }
    if (scope) {
      scope.addEventListener('change', function () {
        scope.title = scope.options[scope.selectedIndex].textContent.trim();
      });
    }

    function closePanel() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function renderGroup(label, items) {
      if (!items.length) return '';
      return '<div class="predictive-group"><strong class="predictive-group__heading">' + label + '</strong>' + items.join('') + '</div>';
    }

    function renderTextResult(item, typeLabel) {
      return [
        '<a class="predictive-item predictive-item--text" href="' + escapeHtml(item.url || '#') + '">',
        '<span class="predictive-item__type">' + typeLabel + '</span>',
        '<span><strong>' + escapeHtml(item.title || '') + '</strong></span>',
        '</a>'
      ].join('');
    }

    function matchingShortcuts(term) {
      var words = term.toLowerCase().split(/\s+/).filter(Boolean);
      var seen = {};
      return shortcuts.filter(function (item) {
        var haystack = ((item.title || '') + ' ' + (item.keywords || '')).toLowerCase();
        var matches = words.every(function (word) { return haystack.indexOf(word) !== -1; });
        if (!matches || !item.url || seen[item.url]) return false;
        seen[item.url] = true;
        return true;
      }).slice(0, 4);
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var term = input.value.trim();
      if (term.length < 2) {
        closePanel();
        panel.innerHTML = '';
        return;
      }

      timer = setTimeout(function () {
        var selectedTypes = scope ? scope.value : 'product,page,article';
        var url = '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=' + encodeURIComponent(selectedTypes) + '&resources[limit]=4';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (payload) {
            var results = payload.resources && payload.resources.results ? payload.resources.results : {};
            var products = results.products || [];
            var pages = results.pages || [];
            var articles = results.articles || [];
            var quickLinks = selectedTypes === 'product' ? [] : matchingShortcuts(term);

            var productMarkup = products.map(function (product) {
              var image = product.image
                ? '<img src="' + product.image + '" alt="' + escapeHtml(product.title) + '">'
                : '<span class="predictive-item__placeholder"></span>';
              return [
                '<a class="predictive-item" href="' + product.url + '">',
                image,
                '<span><strong>' + escapeHtml(product.title) + '</strong><br><small>' + escapeHtml(product.price || '') + '</small></span>',
                '</a>'
              ].join('');
            });

            var pageMarkup = pages.map(function (page) { return renderTextResult(page, 'PAGE'); });
            var articleMarkup = articles.map(function (article) { return renderTextResult(article, 'GUIDE'); });
            var shortcutMarkup = quickLinks.map(function (item) { return renderTextResult(item, 'LINK'); });
            var allResultsUrl = '/search?q=' + encodeURIComponent(term) + '&type=' + encodeURIComponent(selectedTypes) + '&options%5Bprefix%5D=last';
            var markup = [
              renderGroup('Products', productMarkup),
              renderGroup('Guides', articleMarkup),
              renderGroup('Pages', pageMarkup),
              renderGroup('Store links', shortcutMarkup)
            ].join('');

            if (!markup) markup = '<p class="predictive-empty">No matching products, guides, or pages yet.</p>';
            panel.innerHTML = markup + '<a class="predictive-all" href="' + allResultsUrl + '">View all results for “' + escapeHtml(term) + '”</a>';
            panel.hidden = false;
            input.setAttribute('aria-expanded', 'true');
          })
          .catch(function () {
            closePanel();
          });
      }, 180);
    });

    if (scope) scope.addEventListener('change', function () { input.dispatchEvent(new Event('input')); });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePanel();
    });

    document.addEventListener('click', function (event) {
      if (!panel.contains(event.target) && event.target !== input) {
        closePanel();
      }
    });
  }

  function initVariantForms(root) {
    qsa('.product-form', root).forEach(function (form) {
      if (form.dataset.variantReady === 'true') return;
      var variantsNode = qs('[data-product-variants]', form);
      var variantInput = qs('[data-variant-id]', form);
      var addButton = qs('[data-add-to-cart]', form);
      var selects = qsa('[data-variant-selects] select', form);
      if (!variantsNode || !variantInput || !addButton || !selects.length) return;
      form.dataset.variantReady = 'true';

      var variants = [];
      try {
        variants = JSON.parse(variantsNode.textContent);
      } catch (error) {
        return;
      }

      function updateVariant() {
        var selected = selects.map(function (select) {
          return select.value;
        });
        var matched = variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === selected[index];
          });
        });

        if (!matched) {
          addButton.disabled = true;
          addButton.textContent = 'Unavailable';
          return;
        }

        variantInput.value = matched.id;
        addButton.disabled = !matched.available;
        addButton.textContent = matched.available ? 'Add to cart' : 'Sold out';

        qsa('[data-sticky-variant]').forEach(function (input) {
          input.value = matched.id;
        });
        qsa('[data-sticky-add]').forEach(function (button) {
          button.disabled = !matched.available;
          var label = qs('[data-sticky-label]', button);
          if (label) label.textContent = matched.available ? 'Add to cart' : 'Sold out';
        });
        qsa('[data-sticky-price]').forEach(function (price) {
          var currency = price.getAttribute('data-currency-code') || 'USD';
          price.textContent = formatMoney(matched.price, currency);
        });

        var currencyNode = qs('[data-currency-code]', form);
        var currency = currencyNode ? currencyNode.getAttribute('data-currency-code') : 'USD';
        qsa('[data-product-current-price], [data-purchase-price]', form).forEach(function (price) {
          price.textContent = formatMoney(matched.price, currency);
        });
        var compare = qs('[data-product-compare-price]', form);
        var savingBadge = qs('[data-saving-percent]', form);
        var savingLine = qs('[data-saving-line]', form);
        var savingAmount = qs('[data-saving-amount]', form);
        var hasSaving = matched.compare_at_price && matched.compare_at_price > matched.price;
        if (compare) {
          compare.hidden = !hasSaving;
          compare.textContent = hasSaving ? formatMoney(matched.compare_at_price, currency) : '';
        }
        if (savingBadge) {
          savingBadge.hidden = !hasSaving;
          savingBadge.textContent = hasSaving ? 'Save ' + Math.round((matched.compare_at_price - matched.price) * 100 / matched.compare_at_price) + '%' : '';
        }
        if (savingLine) savingLine.hidden = !hasSaving;
        if (savingAmount) savingAmount.textContent = hasSaving ? formatMoney(matched.compare_at_price - matched.price, currency) : '';
        var sku = qs('[data-current-sku]', form);
        if (sku) sku.textContent = matched.sku ? 'SKU: ' + matched.sku : '';
        var stock = qs('[data-stock-label]', form);
        if (stock) {
          stock.textContent = matched.available ? 'In stock and ready to order' : 'This option is sold out';
          stock.classList.toggle('in-stock', matched.available);
          stock.classList.toggle('out-stock', !matched.available);
        }
        selects.forEach(function (select) {
          var optionLabel = form.querySelector('label[for="' + select.id + '"] span');
          if (optionLabel) optionLabel.textContent = select.value;
        });

        var wishlistNode = qs('[data-wishlist-product]');
        if (wishlistNode) {
          try {
            var wishlistProduct = JSON.parse(wishlistNode.textContent);
            wishlistProduct.variantId = matched.id;
            wishlistProduct.price = matched.price;
            wishlistProduct.compareAtPrice = matched.compare_at_price || 0;
            wishlistProduct.available = matched.available;
            wishlistNode.textContent = JSON.stringify(wishlistProduct);
            var saved = readWishlist();
            var savedIndex = saved.findIndex(function (item) { return String(item.id) === String(wishlistProduct.id); });
            if (savedIndex !== -1) {
              saved[savedIndex] = wishlistProduct;
              writeWishlist(saved);
            }
          } catch (error) {}
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', matched.id);
        window.history.replaceState({}, '', url.toString());
      }

      selects.forEach(function (select) {
        select.addEventListener('change', updateVariant);
      });
    });
  }

  function initProductTabs(root) {
    qsa('[data-product-tabs]', root).forEach(function (tabs) {
      qsa('[data-product-tab]', tabs).forEach(function (button) {
        if (button.dataset.tabReady === 'true') return;
        button.dataset.tabReady = 'true';
        button.addEventListener('click', function () {
          var target = button.getAttribute('data-product-tab');
          qsa('[data-product-tab]', tabs).forEach(function (tab) {
            var active = tab === button;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          qsa('[data-product-panel]', tabs).forEach(function (panel) {
            var active = panel.getAttribute('data-product-panel') === target;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        });
      });
    });
  }

  function initCollectionFilters(root) {
    qsa('[data-collection-page]', root).forEach(function (page) {
      var toggle = qs('[data-filter-toggle]', page);
      var filters = qs('[data-collection-filters]', page);
      var close = qs('[data-filter-close]', page);
      if (!toggle || !filters || toggle.dataset.filterReady === 'true') return;
      toggle.dataset.filterReady = 'true';

      function setOpen(open) {
        filters.classList.toggle('is-open', open);
        document.body.classList.toggle('filters-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      toggle.addEventListener('click', function () { setOpen(true); });
      if (close) close.addEventListener('click', function () { setOpen(false); });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') setOpen(false);
      });
    });
  }

  function initProductGalleries(root) {
    qsa('[data-product-gallery]', root).forEach(function (gallery) {
      var main = qs('[data-gallery-main]', gallery);
      if (!main) return;
      qsa('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        if (thumb.dataset.galleryReady === 'true') return;
        thumb.dataset.galleryReady = 'true';
        thumb.addEventListener('click', function () {
          main.src = thumb.getAttribute('data-gallery-src');
          main.alt = thumb.getAttribute('data-gallery-alt') || '';
          qsa('[data-gallery-thumb]', gallery).forEach(function (item) {
            item.classList.toggle('is-active', item === thumb);
          });
        });
      });
    });
  }

  function initQuickAdd(root) {
    qsa('.quick-add-form', root).forEach(function (form) {
      if (form.dataset.quickAddReady === 'true') return;
      form.dataset.quickAddReady = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = qs('button[type="submit"]', form);
        if (!button || button.disabled) return;
        var isIconButton = button.classList.contains('product-cart-fab');
        var originalText = button.textContent;
        var originalLabel = button.getAttribute('aria-label');
        button.disabled = true;
        if (isIconButton) {
          button.classList.add('is-loading');
          button.setAttribute('aria-label', 'Adding to cart');
        } else {
          button.textContent = 'Adding...';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to add item');
            return fetch('/cart.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            updateCartCounts(cart);
            showCartToast(form.getAttribute('data-product-title'));
            if (isIconButton) button.setAttribute('aria-label', 'Added to cart');
            else button.textContent = 'Added to cart';
            button.classList.remove('is-loading');
            button.classList.add('is-added');
            setTimeout(function () {
              button.disabled = false;
              if (isIconButton) button.setAttribute('aria-label', originalLabel || 'Add to cart');
              else button.textContent = originalText;
              button.classList.remove('is-added');
            }, 1800);
          })
          .catch(function () {
            button.disabled = false;
            button.classList.remove('is-loading');
            button.classList.add('is-error');
            if (isIconButton) button.setAttribute('aria-label', 'Unable to add. Try again');
            else button.textContent = 'Try again';
            setTimeout(function () {
              if (isIconButton) button.setAttribute('aria-label', originalLabel || 'Add to cart');
              else button.textContent = originalText;
              button.classList.remove('is-error');
            }, 1800);
          });
      });
    });
  }

  function initProductAdd(root) {
    qsa('[data-product-form]', root).forEach(function (form) {
      if (form.dataset.productAddReady === 'true') return;
      form.dataset.productAddReady = 'true';
      form.addEventListener('submit', function (event) {
        var button = event.submitter || qs('[data-add-to-cart]', form);
        if (!button || !button.matches('[data-add-to-cart]') || button.disabled) return;
        event.preventDefault();
        var originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to add item');
            return fetch('/cart.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            updateCartCounts(cart);
            showCartToast(form.getAttribute('data-product-title'));
            button.textContent = 'Added to cart';
            button.classList.add('is-added');
            window.setTimeout(function () {
              button.disabled = false;
              button.textContent = originalText;
              button.classList.remove('is-added');
            }, 1800);
          })
          .catch(function () {
            button.disabled = false;
            button.textContent = 'Try again';
            button.classList.add('is-error');
            window.setTimeout(function () {
              button.textContent = originalText;
              button.classList.remove('is-error');
            }, 1800);
          });
      });
    });
  }

  function initStickyBuy(root) {
    qsa('[data-sticky-buy]', root).forEach(function (bar) {
      if (bar.dataset.stickyReady === 'true') return;
      var primaryAdd = qs('[data-add-to-cart]');
      if (!primaryAdd) return;
      bar.dataset.stickyReady = 'true';

      function update() {
        var mobile = window.matchMedia('(max-width: 700px)').matches;
        bar.classList.toggle('is-visible', mobile || primaryAdd.getBoundingClientRect().bottom < 0);
      }

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initHeroSliders(root) {
    qsa('[data-hero-slider]', root).forEach(function (slider) {
      if (slider.dataset.heroReady === 'true') return;
      slider.dataset.heroReady = 'true';
      var slides = qsa('[data-hero-slide]', slider);
      var dots = qsa('[data-hero-dot]', slider);
      var previous = qs('[data-hero-prev]', slider);
      var next = qs('[data-hero-next]', slider);
      var current = 0;
      var interval = null;
      var seconds = Number(slider.getAttribute('data-autoplay') || 0);
      if (slides.length < 2) return;

      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === current);
        });
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === current);
        });
      }

      function restart() {
        if (interval) window.clearInterval(interval);
        if (seconds > 0) interval = window.setInterval(function () { show(current + 1); }, seconds * 1000);
      }

      if (previous) previous.addEventListener('click', function () { show(current - 1); restart(); });
      if (next) next.addEventListener('click', function () { show(current + 1); restart(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { show(Number(dot.getAttribute('data-hero-dot'))); restart(); });
      });
      slider.addEventListener('mouseenter', function () { if (interval) window.clearInterval(interval); });
      slider.addEventListener('mouseleave', restart);
      restart();
    });
  }

  function initQuantitySteppers(root) {
    qsa('[data-quantity-stepper]', root).forEach(function (stepper) {
      if (stepper.dataset.quantityReady === 'true') return;
      stepper.dataset.quantityReady = 'true';
      var input = qs('input[type="number"]', stepper);
      if (!input) return;
      qsa('[data-quantity-change]', stepper).forEach(function (button) {
        button.addEventListener('click', function () {
          var minimum = Number(input.min || 0);
          var nextValue = Number(input.value || 0) + Number(button.getAttribute('data-quantity-change') || 0);
          input.value = Math.max(minimum, nextValue);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initInteractiveSections(root) {
    initVariantForms(root || document);
    initProductTabs(root || document);
    initCollectionFilters(root || document);
    initProductGalleries(root || document);
    initQuickAdd(root || document);
    initProductAdd(root || document);
    initStickyBuy(root || document);
    initHeroSliders(root || document);
    initQuantitySteppers(root || document);
    initWishlist(root || document);
    initProductSharing(root || document);
    initProductRecommendations(root || document);
    initBrandDirectories(root || document);
    initArticleTools(root || document);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initCategoryFlyouts();
    initCountdown();
    initPredictiveSearch();
    initBackToTop();
    initInteractiveSections(document);
    trackCurrentProduct();
    renderRecent();
    renderWishlist();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initInteractiveSections(event.target);
  });
})();
